import { render, staticRenderFns } from "./WeddingDate.vue?vue&type=template&id=93379186&scoped=true&"
import script from "./WeddingDate.vue?vue&type=script&lang=js&"
export * from "./WeddingDate.vue?vue&type=script&lang=js&"
import style0 from "./WeddingDate.vue?vue&type=style&index=0&id=93379186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93379186",
  null
  
)

export default component.exports